<template>
  <div class="landing-social-proof">
    <div class="landing-social-proof__container">
      <h2 class="landing-social-proof__title">
        {{ $t('b2b__landing_page__social_proof__title') }}
      </h2>

      <p class="landing-social-proof__subtitle">
        {{ $t('b2b__landing_page__social_proof__subtitle') }}
      </p>

      <div class="landing-social-proof__cards">
        <article
          v-for="(card, index) in cards"
          :key="index"
          class="landing-social-proof__card"
        >
          <h3 class="landing-social-proof__card-value">
            {{ $t(card.value) }}
          </h3>

          <p class="landing-social-proof__card-description">
            {{ $t(card.description) }}
          </p>
        </article>
      </div>
    </div>
  </div>
</template>

<script setup>
const cards = [
  {
    value: 'b2b__landing_page__social_proof__metric_one__value',
    description: 'b2b__landing_page__social_proof__metric_one__description',
  },
  {
    value: 'b2b__landing_page__social_proof__metric_two__value',
    description: 'b2b__landing_page__social_proof__metric_two__description',
  },
]
</script>

<style lang="scss" scoped>
.landing-social-proof {
  padding: $kds-space-2_5x 10px 40px;

  @include media-up(lg) {
    padding: $kds-space-3x 10px 72px;
  }

  &__container {
    @extend %container;
    margin: 0 auto;
    text-align: center;
  }

  &__title {
    @include kds-typography-display-large;
    color: $kds-color-text-primary;
    margin: 0;
  }

  &__subtitle {
    @include kds-typography-paragraph-large;
    margin: $kds-space-0_5x 0 $kds-space-3x;
  }

  &__cards {
    display: grid;
    gap: 12px;
    grid-template-columns: 1fr;

    @include media-up(md) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 16px;
    }
  }

  &__card {
    background-color: $kds-color-background-base;
    border: 1px solid $kds-color-background-strong;
    border-radius: 12px;
    padding: $kds-space-2x;
    box-shadow: 0 2px 6px rgba(10, 28, 64, 0.08);
  }

  &__card-value {
    @include kds-typography-display-small;
    color: $kds-color-text-interactive-accent;
    margin: 0;
  }

  &__card-description {
    @include kds-typography-paragraph-large;
    margin: 6px 0 0;
  }
}
</style>
